import { gql } from '@apollo/client';
import { surfaceUnionFragment } from 'graphql/surface-node/fragments/surface-node-fragment/surface-node-union-fragment';

export const surfaceNodeSharedSubscription = gql`
  subscription surfaceNodeShared($surface: ID!) {
    surfaceNodeShared(surface: $surface) {
      surface {
        ...surfaceNodeUnionDetails
      }
      sharedReference {
        ...surfaceNodeUnionDetails
      }
    }
  }
  ${surfaceUnionFragment}
`;
